namespace GeniuzPOS.PosShift {
    export interface PosTranDtRow {
        Id?: number;
        DocNo?: string;
        LineItemNo?: number;
        LineItemType?: string;
        ItemDesc?: string;
        RefLineItemNo?: number;
        PosFg?: number;
        PluCode?: string;
        Qty?: number;
        SerialNo?: string;
        UnitPrice?: number;
        ExPrice?: number;
        DiscPc?: number;
        Discamt?: number;
        DiscCouponType?: string;
        DiscCouponNo?: string;
        PromoId?: string;
        ChargePc?: number;
        ChargeAmt?: number;
        ItemVatType?: string;
        ItemPromoFg?: number;
        ItemPromoId?: string;
        ItemDiscount?: number;
        ItemCharge?: number;
        ItemNetExprice?: number;
        AllocatedBillDiscount?: number;
        ItemNetSales?: number;
        ItemVatRate?: number;
        ItemVat?: number;
        QtyRefund?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        GpPc?: number;
        VenderSharing?: number;
        AllocatedBillDiscountVat?: number;
    }

    export namespace PosTranDtRow {
        export const idProperty = 'Id';
        export const nameProperty = 'DocNo';
        export const localTextPrefix = 'PosShift.PosTranDt';
        export const lookupKey = 'PosTranDtRow';

        export function getLookup(): Q.Lookup<PosTranDtRow> {
            return Q.getLookup<PosTranDtRow>('PosTranDtRow');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            DocNo = "DocNo",
            LineItemNo = "LineItemNo",
            LineItemType = "LineItemType",
            ItemDesc = "ItemDesc",
            RefLineItemNo = "RefLineItemNo",
            PosFg = "PosFg",
            PluCode = "PluCode",
            Qty = "Qty",
            SerialNo = "SerialNo",
            UnitPrice = "UnitPrice",
            ExPrice = "ExPrice",
            DiscPc = "DiscPc",
            Discamt = "Discamt",
            DiscCouponType = "DiscCouponType",
            DiscCouponNo = "DiscCouponNo",
            PromoId = "PromoId",
            ChargePc = "ChargePc",
            ChargeAmt = "ChargeAmt",
            ItemVatType = "ItemVatType",
            ItemPromoFg = "ItemPromoFg",
            ItemPromoId = "ItemPromoId",
            ItemDiscount = "ItemDiscount",
            ItemCharge = "ItemCharge",
            ItemNetExprice = "ItemNetExprice",
            AllocatedBillDiscount = "AllocatedBillDiscount",
            ItemNetSales = "ItemNetSales",
            ItemVatRate = "ItemVatRate",
            ItemVat = "ItemVat",
            QtyRefund = "QtyRefund",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            GpPc = "GpPc",
            VenderSharing = "VenderSharing",
            AllocatedBillDiscountVat = "AllocatedBillDiscountVat"
        }
    }
}
